import type { Category } from '../types.ts'

const BASE = '/api/categories'

export async function getCategoriesByUser(userId: number): Promise<Category[]> {
  const res = await fetch(`${BASE}?user_id=${userId}`)
  if (!res.ok) throw new Error('Erro ao buscar categorias do usuário')
  return res.json() as Promise<Category[]>
}

export type CategoryInput = {
  user_id: number
  parent_id: number | null
  name: string
  slug: string
}

export async function createCategory(data: CategoryInput): Promise<Category> {
  const res = await fetch(BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
  if (!res.ok) throw new Error('Erro ao criar categoria')
  return res.json() as Promise<Category>
}

export async function updateCategory(
  id: number,
  data: Partial<Omit<CategoryInput, 'user_id'>> & { user_id: number },
): Promise<Category> {
  const res = await fetch(`${BASE}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
  if (!res.ok) throw new Error('Erro ao atualizar categoria')
  return res.json() as Promise<Category>
}

export async function deleteCategory(id: number, userId: number): Promise<void> {
  const res = await fetch(`${BASE}/${id}?user_id=${userId}`, { method: 'DELETE' })
  if (!res.ok) {
    let message = 'Erro ao deletar categoria'

    try {
      const data = await res.json() as { error?: string }
      if (data.error) {
        message = data.error
      }
    } catch {
      // Mantemos a mensagem padrão se a resposta não vier em JSON.
    }

    throw new Error(message)
  }
}
